/* eslint-disable no-unused-vars */
/* eslint-disable no-nested-ternary */
import { Typography, Image, Tooltip } from 'antd';
import 'antd/lib/image/style/index.css';
import 'antd/lib/tooltip/style/index.css';
import 'antd/lib/typography/style/index.css';
import { createUseStyles } from 'react-jss';
import CCS2Icon from '../assets/connectorLogos/ccs2.png';
import CCS1Icon from '../assets/connectorLogos/ccs1.png';
import ChaDeMoIcon from '../assets/connectorLogos/chademo.png';

const { Text } = Typography;

const useStyles = createUseStyles({
  connectorLogo: {
    width: '80px !important',
    height: '105px !important',
    textAlign: 'center',
  },
});

export default function Connector({ connectorId, type }) {
  const classes = useStyles();
  function diplayConnectorType() {
    return {
      CCS1: 'CCS 1',
      CCS2: 'CCS 2',
      CHADEMO: 'CHAdeMO',
    }[type];
  }
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        paddingRight: '10px',
        paddingLeft: '10px',
        border: '1px solid #e4e7e8',
        marginRight: '10px',
        borderRadius: '5px',
        paddingTop: '10px',
        paddingBottom: '10px',
        width: '130px',
      }}
    >
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '130px',
          marginLeft: '-11px',
          marginTop: '-11px',
          borderTopLeftRadius: '5px',
          borderTopRightRadius: '5px',
          paddingLeft: '10px',
          paddingRight: '10px',
          paddingTop: '5px',
          paddingBottom: '5px',
          backgroundColor: '#2675b8',
          color: 'white',
        }}
      >
        <div>{diplayConnectorType()}</div>
        <div
          style={{
            border: '1px solid white',
            borderRadius: '50%',
            height: '25px',
            width: '25px',
            textAlign: 'center',
            backgroundColor: '#2675b8',
            color: 'white',
          }}
        >
          {connectorId}
        </div>
      </div>
      <div style={{ display: 'flex', justifyContent: 'center' }}>
        {type === 'CCS1' ? (
          <Tooltip title={diplayConnectorType()} placement="bottom">
            <Image
              src={CCS1Icon}
              alt="CCS1"
              preview={false}
              className={classes.connectorLogo}
            />
          </Tooltip>
        ) : type === 'CCS2' ? (
          <Tooltip title={diplayConnectorType()} placement="bottom">
            <Image
              src={CCS2Icon}
              alt="CCS2"
              preview={false}
              className={classes.connectorLogo}
            />
          </Tooltip>
        ) : type === 'CHADEMO' ? (
          <Tooltip title={diplayConnectorType()} placement="bottom">
            <Image
              src={ChaDeMoIcon}
              alt="CHADEMO"
              preview={false}
              className={classes.connectorLogo}
            />
          </Tooltip>
        ) : (
          <></>
        )}
      </div>
    </div>
  );
}
